import HomePage from "../components/Home";

export default function Home() {
  return <HomePage />;
}
